export enum SegmentStatus {
    Undefined = 0,
    Ok = 1,
    SourceReach500Limit = 10,
    TargetReach500Limit = 20,
    SourceAndTargetReach500Limit = 30,
}